import React, { useState } from "react";
import { exportGuarantorExposureAsCSV } from "../../sdk/guarantors/guarantors";
import { toast } from "react-toastify";

const ExportGuarantorExposureCSV = ({
  from,
  to,
  search,
  page,
  limit,
  logAudit,
  guarantors,
}) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);

      await exportGuarantorExposureAsCSV({
        from,
        to,
        search,
        page,
        limit,
      });

      toast?.success("CSV exported successfully 🎉");

      logAudit({
        category: "Guarantors",
        actionCode: "EXPORT_GUARANTORS",
        description: "Exported guarantors list",
        page: "Guarantors",
        tab: "Guarantors List",
        section: "Export",
        metadata: {
          route: "/dashboard/guarantors",
          totalRecords: guarantors?.length,
        },
      });
    } catch (error) {
      toast?.error(error?.message || "Failed to export CSV");
      // Audit failed export
      logAudit({
        category: "Guarantors",
        actionCode: "EXPORT_GUARANTORS_FAILED",
        description: "Failed to export guarantors list",
        page: "Guarantors",
        tab: "Guarantors List",
        section: "Export",
        metadata: {
          route: "/dashboard/guarantors",
          error: error?.message || "Failed to export CSV",
          totalRecords: guarantors?.length,
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className="text-[#FFFFFF] bg-[#0C722F] hover:bg-[#0C722F] disabled:opacity-70 focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
    >
      {isExporting ? (
        <div className="flex items-center gap-2">
          <svg
            className="animate-spin h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
            />
          </svg>
          Exporting...
        </div>
      ) : (
        "EXPORT CSV"
      )}
    </button>
  );
};

export default ExportGuarantorExposureCSV;
